<template>
  <div class="text-center max-w-xl">
    <!-- Title -->
    <h1 class="text-4xl text-gray-900 mb-4">
      Plan Not Found 🔍
    </h1> 

    <!-- Description -->
    <p class="text-gray-600 mb-10">
      This subscription plan does not exist or is no longer available.
    </p>

    <!-- Reload Button -->
    <button
      @click="reloadPage"
      class="inline-flex items-center justify-center px-10 py-4 bg-gray-900 text-white text-lg font-medium rounded-full hover:bg-gray-800 transition-all duration-200 shadow-lg"
    >
      Try Again
    </button>
  </div>
</template>

<script setup lang="ts">
const reloadPage = () => {
  window.location.reload()
}
</script>
